import { render, staticRenderFns } from "./DetalhesLoteInfo.vue?vue&type=template&id=6a66a56e"
import script from "./DetalhesLoteInfo.vue?vue&type=script&lang=js"
export * from "./DetalhesLoteInfo.vue?vue&type=script&lang=js"
import style0 from "./DetalhesLoteInfo.vue?vue&type=style&index=0&id=6a66a56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports